export default class PvrService {
	constructor(apiService) {
		this.apiService = apiService
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('pvrs/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/PvrService.js